// @flow
import createReducer from "common/reducerBase";
import { doSelection, doMultipleSelection } from "tabs/common/reducerMethods";
import ImageSearchRecord from "../data/ImageSearchRecord";
import { types as ats } from "../actions";

// todo: refactor to use context (like instagram) so can share code better with 3rd party tabs

export default {
	imageSearch: createReducer(ImageSearchRecord(), {

		[ats.SET_SEARCH_TERM]: (state: Object, { payload }) => state.set("searchTerm", payload.value),

		[ats.CLEAR_IMAGE_SELECTION]: (state: Object) => state.replace({
			...state,
			selected: [],
		}),

		[ats.SET_FILE_SELECTION]: doSelection,

		[ats.SET_MULTI_FILE_SELECTION]: doMultipleSelection,

		[ats.SET_IMAGE_SEARCH_START]: (state: Object) => state.merge({
			searchDone: false,
			progressIndicator: true,
			queries: null,
		}),

		[ats.SET_IMAGE_SEARCH_SUCCESS]: (state: Object, { payload }) => state.merge({
			firstSearch: false,
			searchDone: true,
			progressIndicator: false,
			images: payload.images,
			queries: payload.queries,
		}),

		[ats.SET_IMAGE_SEARCH_FAIL]: (state: Object, { payload }) => state.merge({
			searchDone: true,
			progressIndicator: false,
			searchError: payload.error,
		}),

		[ats.CLEAR_SEARCH_ERROR]: (state: Object) => state.set("searchError", null),

		[ats.SET_SEARCH_RIGHT]: (state: Object, { payload }) => state.merge({
			searchRight: payload.right,
			searchRightIndex: payload.index,
		}),

		[ats.SET_SEARCH_SITE]: (state: Object, { payload }) => state.merge({
			searchSite: payload.site,
			searchSiteIndex: payload.index,
		}),

		[ats.RESET_SEARCH]: (state: Object) => ImageSearchRecord().merge({
			searchRight: state.searchRight,
			searchRightIndex: state.searchRightIndex,
			searchSite: state.searchSite,
			searchSiteIndex: state.searchSiteIndex,
			showOptions: state.showOptions,
		}),

		[ats.SET_OPTIONS_VISIBILITY]: (state: Object, { payload }) => state.set("showOptions", payload.show),
	}),
};
